import {
    TEMPLATE_OPEN_MODAL,
    TEMPLATE_CREATE_REQUEST,
    TEMPLATE_CREATE_RESULT,
    TEMPLATE_UPDATE_REQUEST,
    TEMPLATE_UPDATE_RESULT,
    TEMPLATE_SEARCH_REQUEST,
    TEMPLATE_SEARCH_RESULT,
    TEMPLATE_GET_REQUEST,
    TEMPLATE_GET_RESULT,
} from 'Redux/actionTypes';

export const templateOpenModal = (open) => ({
    type: TEMPLATE_OPEN_MODAL,
    payload: open
})

export const templateCreateRequest = (data) => ({
    type: TEMPLATE_CREATE_REQUEST,
    payload: data
})

export const templateCreateResult = (result) => ({
    type: TEMPLATE_CREATE_RESULT,
    payload: result
})

export const templateUpdateRequest = (data) => ({
    type: TEMPLATE_UPDATE_REQUEST,
    payload: data
})

export const templateUpdateResult = (result) => ({
    type: TEMPLATE_UPDATE_RESULT,
    payload: result
})

export const templateSearchRequest = (data) => ({
    type: TEMPLATE_SEARCH_REQUEST,
    payload: data
})

export const templateSearchResult = (result) => ({
    type: TEMPLATE_SEARCH_RESULT,
    payload: result
})

export const templateGetRequest = (data) => ({
    type: TEMPLATE_GET_REQUEST,
    payload: data
})

export const templateGetResult = (result) => ({
    type: TEMPLATE_GET_RESULT,
    payload: result
})